export default __webpack_public_path__ + "static/media/mobile-money.fcb16416.svg";